/**
 * Browser entry point. The app is a React Native (react-native-web) component
 * tree, so it is mounted through AppRegistry like before.
 */
import { AppRegistry } from 'react-native'
import App from '../App'

AppRegistry.registerComponent('main', () => App)
AppRegistry.runApplication('main', {
  rootTag: document.getElementById('root')
})
